// extracted by mini-css-extract-plugin
module.exports = {"imageframe":"NewsItems_imageframe__3BR6F","info":"NewsItems_info__2Kt4I","container":"NewsItems_container__2Aw83","imageContainer":"NewsItems_imageContainer__2C1LD"};